import { render, staticRenderFns } from "./UyapEngeliDialog.vue?vue&type=template&id=00b955c6&scoped=true"
import script from "./UyapEngeliDialog.vue?vue&type=script&lang=ts"
export * from "./UyapEngeliDialog.vue?vue&type=script&lang=ts"
import style0 from "./UyapEngeliDialog.vue?vue&type=style&index=0&id=00b955c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b955c6",
  null
  
)

export default component.exports